import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import WaitingMember from './WaitingMember'

class ParselWaitingMember extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={WaitingMember} {...props}/>
   )
 }
}



export default ParselWaitingMember;
